import React from "react";
import "../Styles/RangeSlider.css";

const RangeSlider = ({
  label,
  unit,
  min,
  max,
  step,
  values,
  setValues,
  leftLabel,
  rightLabel,
  colorClass = "primary",
  noPref,
  setNoPref,
}) => {
  const handleMinChange = (e) => {
    const newMin = parseFloat(e.target.value);
    if (newMin <= values[1]) setValues([newMin, values[1]]);
  };

  const handleMaxChange = (e) => {
    const newMax = parseFloat(e.target.value);
    if (newMax >= values[0]) setValues([values[0], newMax]);
  };

  return (
    <div className="attribute-section">
      <label className="label-title">{label}</label>
      <div className={`range-container ${colorClass}`}>
        <div className="range-header">
          <span className="range-value">
            {unit === "ft"
              ? `${values[0]}ft to ${values[1]}ft`
              : `${values[0]} to ${values[1]} ${unit}`}
          </span>
          {/* {setNoPref && (
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={noPref}
                onChange={() => setNoPref(!noPref)}
              />
              <span className="checkbox-box" />
              <span className="checkbox-text">no preference</span>
            </label>
          )} */}
        </div>

        <div className="slider-wrapper">
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={values[0]}
            onChange={handleMinChange}
          />
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={values[1]}
            onChange={handleMaxChange}
          />
        </div>

        <div className="range-labels">
          <span>{leftLabel}</span>
          <span>{rightLabel}</span>
        </div>
      </div>
    </div>
  );
};

export default RangeSlider;
